export const initialState = {
    loading: false,
    response:{message:null, error: null}
}